export default "__VITE_ASSET__DrjWOvA8__"